import { defineMessages } from 'react-intl';

const messages = defineMessages({
  stepTitle: {
    id: 'registration.personalDetails.stepTitle',
    defaultMessage: 'Your details',
    description: 'Registration personal details step title',
  },
  title: {
    id: 'registration.personalDetails.title',
    defaultMessage: 'Your details',
    description: 'Registration personal details title',
  },
  description: {
    id: 'registration.personalDetails.description',
    defaultMessage: 'Please enter your first and last name.',
    description: 'Registration personal details description',
  },
  nameFormatValidation: {
    id: 'registration.personalDetails.validations.nameFormat',
    defaultMessage: 'Please check the name format',
    description: 'Registration personal details name format validation',
  },
});

export default messages;
